module.exports = __webpack_public_path__ + "img/product_banner.1bb629ef.webp";